var map = {
	"./3.webp": 686613,
	"./3_de.webp": 178489,
	"./3_es.webp": 945289,
	"./3_fr.webp": 497508,
	"./3_it.webp": 895804,
	"./3_jp.webp": 345744
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 253172;